




import VueOptions from '@utils/VueOptions'

settings = 
  name: "SupplierListItem"
  vue:
    props: ['supplierItem']

export default VueOptions.vue settings
